import { store } from '../components/App'

export const buildDefaultHeaders = getState => ({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    Authorization: `Basic ${btoa(`${store.getState().auth.token}:empty`)}`,
  },
});

export const arrayBufferToBase64 = (buffer) => {
  let binary = '';
  const bytes = [].slice.call(new Uint8Array(buffer));

  bytes.forEach((b) => binary += String.fromCharCode(b));

  const base64Flag = 'data:image/jpeg;base64,';
  const imageStr = window.btoa(binary);

  return base64Flag + imageStr;
};
